export const coordinatesStates = [
    {
        uf: "AC",
        lat: -9.136,
        lgn: -70.302,
        zoom: 7,
    },
    {
        uf: "AL",
        lat: -9.7362,
        lgn: -36.6006,
        zoom: 8,
    },
    {
        uf: "AP",
        lat: 1.720,
        lgn: -52.107,
        zoom: 7,
    },
    {
        uf: "AM",
        lat: -3.815,
        lgn: -64.948,
        zoom: 5,
    },
    {
        uf: "BA",
        lat: -13.514,
        lgn: -41.903,
        zoom: 6,
    },
    {
        uf: "CE",
        lat: -5.222,
        lgn: -39.251,
        zoom: 7,
    },
    {
        uf: "DF",
        lat: -15.7756,
        lgn: -47.7971,
        zoom: 11,
    },
    {
        uf: "ES",
        lat: -19.674,
        lgn: -35.254,
        zoom: 6,
    },
    {
        uf: "GO",
        lat: -15.972,
        lgn: -49.578,
        zoom: 6,
    },
    {
        uf: "MA",
        lat: -5.530,
        lgn: -45.223,
        zoom: 6,
    },
    {
        uf: "MT",
        lat: -12.748,
        lgn: -55.920,
        zoom: 6,
    },
    {
        uf: "MS",
        lat: -20.660,
        lgn: -54.546,
        zoom: 6,
    },
    {
        uf: "MG",
        lat: -18.633,
        lgn: -45.451,
        zoom: 6,
    },
    {
        uf: "PA",
        lat: -3.645,
        lgn: -52.427,
        zoom: 6,
    },
    {
        uf: "PB",
        lat: -7.166,
        lgn: -36.683,
        zoom: 8,
    },
    {
        uf: "PR",
        lat: -24.637,
        lgn: -51.240,
        zoom: 6,
    },
    {
        uf: "PE",
        lat: -4.199,
        lgn: -35.252,
        zoom: 6,
    },
    {
        uf: "PI",
        lat: -6.774,
        lgn: -43.198,
        zoom: 6,
    },
    {
        uf: "RJ",
        lat: -22.230,
        lgn: -42.760,
        zoom: 6,
    },
    {
        uf: "RN",
        lat: -5.318,
        lgn: -36.099,
        zoom: 6,
    },
    {
        uf: "RS",
        lat: -30.535,
        lgn: -53.590,
        zoom: 6,
    },
    {
        uf: "RO",
        lat: -10.845,
        lgn: -63.290,
        zoom: 6,
    },
    {
        uf: "RR",
        lat: 1.841,
        lgn: -61.853,
        zoom: 6,
    },
    {
        uf: "SC",
        lat: -27.704,
        lgn: -50.974,
        zoom: 6,
    },
    {
        uf: "SP",
        lat: -22.665,
        lgn: -48.636,
        zoom: 6,
    },
    {
        uf: "SE",
        lat: -10.543,
        lgn: -37.263,
        zoom: 7,
    },
    {
        uf: "TO",
        lat: -9.342,
        lgn: -48.219,
        zoom: 6,
    },
]
export const coordinatesRegions = [
  {
      region: "Norte",
      lat: -3.4167,
      lgn: -65.8561,
      zoom: 5,
  },
  {
      region: "Nordeste",
      lat: -9.6500,
      lgn: -37.4500,
      zoom: 5,
  },
  {
      region: "Centro-Oeste",
      lat: -15.8270,
      lgn: -47.9200,
      zoom: 5,
  },
  {
      region: "Sudeste",
      lat: -22.9068,
      lgn: -43.1729,
      zoom: 5,
  },
  {
      region: "Sul",
      lat: -30.0277,
      lgn: -51.2287,
      zoom: 5,
  },
];
